import { useCredits } from "@lib/hooks/use-credits"
import { PlanType, usePlan } from "@lib/hooks/use-plan"

export type UseCreditDetailsPayload = {
  remainingCreditsThisPeriod: number | null
  usedCreditsThisPeriod: number
  totalCreditsInThisPeriod: number
  usedTopUps: number
  planType: PlanType
}

export function useCreditDetails(): UseCreditDetailsPayload | null {
  const { data: creditsData } = useCredits()
  const { data: planData } = usePlan()
  if (!creditsData || !planData) {
    return null
  }

  return {
    remainingCreditsThisPeriod: creditsData.remainingCreditsThisPeriod,
    usedCreditsThisPeriod: creditsData.usedCreditsThisPeriod,
    totalCreditsInThisPeriod: creditsData.totalCreditsInThisPeriod,
    usedTopUps: creditsData.usedTopUps || 0,
    planType: planData.type,
  }
}
